import axios from "axios";
import jwt from "./jwt";

// config para la instancia de axios a usar en los request.
const api = axios.create({
    baseURL: '/dash',
    timeout: import.meta.env.VITE_APP_API_REQUEST_TIMEOUT,
    maxRedirects: 0,
});

api.interceptors.request.use(
    (config) => {
        const bearerToken = jwt.getToken();
        if (bearerToken) {
            config.headers.Authorization = `Bearer ${bearerToken}`;
        } else {
            delete api.defaults.headers.common.Authorization;
        }
        return config;
    },
    (err) => Promise.reject(err)
);

export default api;